// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const WhyChooseSection = registerClientReference(
    function() { throw new Error("Attempted to call WhyChooseSection() from the server but WhyChooseSection is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/components/WhyChooseSection/WhyChooseSection.tsx <module evaluation>",
    "WhyChooseSection",
);
export default registerClientReference(
    function() { throw new Error("Attempted to call the default export of [project]/src/components/WhyChooseSection/WhyChooseSection.tsx <module evaluation> from the server, but it's on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/components/WhyChooseSection/WhyChooseSection.tsx <module evaluation>",
    "default",
);
